import { render } from "./TheConfirm.vue?vue&type=template&id=7eb64078"
import script from "./TheConfirm.vue?vue&type=script&lang=js"
export * from "./TheConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__